'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _CaseDocuments = require('./CaseDocuments');

var _CaseDocuments2 = _interopRequireDefault(_CaseDocuments);

var _DocumentTemplatesTable = require('./DocumentTemplates/DocumentTemplatesTable');

var _DocumentTemplatesTable2 = _interopRequireDefault(_DocumentTemplatesTable);

var _HCFAFormWell = require('./HCFAFormWell');

var _HCFAFormWell2 = _interopRequireDefault(_HCFAFormWell);

var _CaseLienDocuments = require('./CaseLienDocuments');

var _CaseLienDocuments2 = _interopRequireDefault(_CaseLienDocuments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var TabDocuments = (_dec = (0, _mobxReact.inject)('FunderStore', 'CaseStore', 'SessionStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(TabDocuments, _Component);

  function TabDocuments() {
    _classCallCheck(this, TabDocuments);

    return _possibleConstructorReturn(this, (TabDocuments.__proto__ || Object.getPrototypeOf(TabDocuments)).apply(this, arguments));
  }

  _createClass(TabDocuments, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          id = _props._case.id,
          CaseStore = _props.CaseStore;

      CaseStore.fetchCaseDocuments(id);
    }
  }, {
    key: 'onDocumentDownloadClick',
    value: function onDocumentDownloadClick(documentId, caseId) {
      this.props.CaseStore.onDocumentDownloadClick('/backend/documents/document-templates/' + documentId + '/case/' + caseId + '/docx');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          _case = _props2._case,
          FunderStore = _props2.FunderStore,
          SessionStore = _props2.SessionStore;


      return _react2.default.createElement(
        'div',
        { className: 'case-detail-tab tab-documents' },
        FunderStore.canSeeHCFAForm && _react2.default.createElement(_HCFAFormWell2.default, null),
        !SessionStore.isMightyFreeUser && _react2.default.createElement(_DocumentTemplatesTable2.default, {
          caseId: _case.id,
          documentTemplates: (0, _mobx.toJS)(FunderStore.caseDocxTemplates),
          onDownloadClick: this.onDocumentDownloadClick
        }),
        _react2.default.createElement(_CaseDocuments2.default, { _case: _case }),
        !SessionStore.isMightyFreeUser && _react2.default.createElement(_CaseLienDocuments2.default, { _case: _case })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return TabDocuments;
}(_react.Component), _class2.propTypes = {
  _case: _propTypes2.default.object.isRequired,
  CaseStore: _propTypes2.default.object,
  FunderStore: _propTypes2.default.object,
  SessionStore: _propTypes2.default.object
}, _temp)) || _class) || _class) || _class);
var _default = TabDocuments;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(TabDocuments, 'TabDocuments', '/app/src/components/page-case/main-documents/TabDocuments.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-documents/TabDocuments.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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